<template>
    <div class="container-fluid ec-bike-listing-filters-box">
        <div class="col-xs-12 col-sm-12 col-md-9 ec-bike-listing-filters-box-controls">
            <form>
                <div class="col-xs-12 col-sm-6 col-md-6">
                    <div class="form-group select2-inverse">
                        <label>{{ isBrandCategory ? 'Marque' : 'Catégorie' }}</label>
                        <select2 :options="$store.state.filtersBox.categories"
                                 :allow-clear="true"
                                 placeholder="Toutes"
                                 class="form-control"
                                 @change="updateCategory"
                                 :initial-value="$store.state.filtersBox.category"
                                 ref="category">
                        </select2>
                    </div>
                </div>
                <div class="col-xs-6 col-sm-3 col-md-3">
                    <div class="form-group select2-inverse">
                        <label>Cadre</label>
                        <select2 :options="frames"
                                 :allow-clear="true"
                                 placeholder="Tous"
                                 class="form-control"
                                 @change="updateFrame"
                                 :initial-value="$store.state.filtersBox.frame"
                                 ref="frame">
                        </select2>
                    </div>
                </div>
                <div class="col-xs-6 col-sm-3 col-md-3">
                    <div class="form-group select2-inverse">
                        <label>Vitesse</label>
                        <select2 :options="$store.state.filtersBox.speeds"
                                 :allow-clear="true"
                                 placeholder="Toutes"
                                 class="form-control"
                                 @change="updateSpeed"
                                 :initial-value="$store.state.filtersBox.speed"
                                 ref="speed">
                        </select2>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6">
                    <div class="form-group">
                        <label>Prix ({{price[0]}}-{{price[1]}} CHF)</label>
                        <vue-slider
                                v-model="price"
                                class="vue-slider-inverse"
                                :min="$store.state.filtersBox.priceLimits[0]"
                                :max="$store.state.filtersBox.priceLimits[1]"
                                :interval="100"
                                :tooltip="false">
                        </vue-slider>
                    </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6">
                    <div class="form-group">
                        <label>Poids ({{weight[0]}}-{{weight[1]}} Kg)</label>
                        <vue-slider
                                v-model="weight"
                                class="vue-slider-inverse"
                                :min="$store.state.filtersBox.weightLimits[0]"
                                :max="$store.state.filtersBox.weightLimits[1]"
                                :interval="1"
                                :tooltip="false">
                        </vue-slider>
                    </div>
                </div>
                <div class="ec-bike-listing-filters-separator"></div>
            </form>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 ec-bike-listing-filters-box-buttons">
            <div class="ec-bike-listing-filter-results">
                <span v-if="loadingResults"><i class="fa fa-spinner fa-spin"></i></span>
                <span v-if="!loadingResults">{{totalResults}}</span>
                résultats
            </div>
            <div class="row">
                <div class="col-xs-6 col-md-12">
                    <a href="#"
                       class="btn btn-primary-inverse"
                       :class="{disabled: !filtersChanged || !totalResults}"
                       @click="applyFilters()">
                        Appliquer<span class="hidden-xs"> les filtres</span>
                    </a>
                </div>
                <div class="col-xs-6 col-md-12">
                    <a href="#"
                       class="btn btn-primary-inverse"
                       :class="{disabled: !filtersNotByDefault}"
                       @click="resetFilters()">
                        Réinitialiser<span class="hidden-xs"> les filtres</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" type="text/scss">
    @import "../../../sass/variables";
    @import "../../../sass/mixins";
    @import "../../../sass/vue-slider";

    .container-fluid.ec-bike-listing-filters-box {
        background: $ec-primary-color;
        padding: $grid-gutter-width/2 $ec-bike-listing-controls-padding;

        > div[class^='col-'] {
            padding-left: 0;
            padding-right: 0;
        }

        .ec-bike-listing-filters-box-controls {
            form {
                margin-left: -$grid-gutter-width/2;
                margin-right: -$grid-gutter-width/2;
            }
        }

        .ec-bike-listing-filter-results {
            font-size: $ec-font-size-h3;
            color: $ec-color-white;
            margin-bottom: $grid-gutter-width/2;
        }

        .btn-primary-inverse {
            margin-bottom: $grid-gutter-width/3;
            width: 100%;
            display: block;
        }

        .select2-inverse .select2-container--default .select2-selection--single,
        .btn-primary {
            @include border-radius(0);
        }

        .select2-inverse .select2-container--default .select2-selection--single .select2-selection__rendered {
            line-height: 28px;
            color: $ec-color-white;
        }

        .ec-bike-listing-filters-separator {
            position: absolute;
            background: $ec-color-white;
        }

        @media (max-width: $screen-xs-max) {
            padding-left: $ec-bike-listing-controls-padding-xs;
            padding-right: $ec-bike-listing-controls-padding-xs;

            .col-xs-6:nth-child(2n+1) {
                clear: none;
            }
        }

        @media (max-width: $screen-sm-max) {
            .ec-bike-listing-filters-separator {
                bottom: -$grid-gutter-width/2;
                left: 0;
                height: 1px;
                width: 100%;
            }

            > div[class^='col-'] {
                &:last-child {
                    margin-top: $grid-gutter-width * 2;
                }
            }
        }

        @media (min-width: $screen-md-min) {
            div[class^='col-'] {
                clear: none;
            }

            .ec-bike-listing-filters-box-controls {
                form {
                    margin-right: $grid-gutter-width/2;
                }
            }

            .ec-bike-listing-filters-box-buttons {
                padding-left: $grid-gutter-width/3*2 !important;
            }

            .ec-bike-listing-filters-separator {
                right: 5px;
                top: 0;
                height: 100%;
                width: 1px;
            }
        }

        @media (max-width: $screen-sm-max) and (min-width: $screen-sm-min) {
            .col-sm-6:nth-child(2n+1) {
                clear: none;
            }
        }
    }
</style>

<script type="text/babel">
    import VueSlider from 'vue-slider-component';
    const GA = require('../../modules/ga');

    export default {
        data: function () {
            return {
                category: '',
                frame: '',
                speed: '',
                price: [0, 0],
                weight: [0, 0],
                totalResults: 0,
                loadingResults: false,
                initialized: false,
                timeout: null,
                xhr: null
            };
        },

        mounted: function () {
            this.initFilters();
            this.totalResults = this.$store.state.filtersBox.results;

            this.$nextTick(function () {
                this.initialized = true;
            });
        },

        computed: {
            frames: function () {
                let storeFrames = this.$store.state.filtersBox.frames;
                let frames = [];

                for (let i in storeFrames) {
                    let frame = storeFrames[i];

                    frames[i] = {
                        id: frame.id,
                        text: '<i class="ec-icon ec-icon-frame-type-{id}"></i> {text}'
                            .replace('{id}', frame.id)
                            .replace('{text}', frame.text)
                    };
                }

                return frames;
            },

            filtersChanged: function () {
                return this.category !== this.$store.state.filtersBox.category ||
                    this.frame !== this.$store.state.filtersBox.frame ||
                    this.speed !== this.$store.state.filtersBox.speed ||
                    JSON.stringify(this.price) !== JSON.stringify(this.getInitialPrice()) ||
                    JSON.stringify(this.weight) !== JSON.stringify(this.getInitialWeight());
            },

            filtersNotByDefault: function () {
                return this.category !== '' ||
                    this.frame !== '' ||
                    this.speed !== '' ||
                    JSON.stringify(this.price) !== JSON.stringify(this.getDefaultPrice()) ||
                    JSON.stringify(this.weight) !== JSON.stringify(this.getDefaultWeight());
            },

            isBrandCategory: function () {
                return this.$store.state.filtersBox.categoryParamName === 'brand';
            }
        },

        components: {
            VueSlider
        },

        watch: {
            price: function () {
                this.onRangeSelectorChanged();
            },

            weight: function () {
                this.onRangeSelectorChanged()
            },
        },

        methods: {
            onRangeSelectorChanged: function () {
                let that = this;

                if (!this.initialized) {
                    return;
                }

                if (this.timeout) {
                    clearTimeout(this.timeout);
                }

                this.timeout = setTimeout(function () {
                    that.loadResults();
                    that.timeout = null;
                }, 300);
            },

            updateCategory: function (category) {
                this.category = category;
                this.loadResults();
            },

            updateFrame: function (frame) {
                this.frame = frame;
                this.loadResults();
            },

            updateSpeed: function (speed) {
                this.speed = speed;
                this.loadResults();
            },

            getInitialPrice: function () {
                return [
                    parseInt(this.$store.state.filtersBox.minPrice || this.$store.state.filtersBox.priceLimits[0], 10),
                    parseInt(this.$store.state.filtersBox.maxPrice || this.$store.state.filtersBox.priceLimits[1], 10)
                ];
            },

            getDefaultPrice: function () {
                return [
                    parseInt(this.$store.state.filtersBox.priceLimits[0], 10),
                    parseInt(this.$store.state.filtersBox.priceLimits[1], 10)
                ];
            },

            getInitialWeight: function () {
                return [
                    parseInt(this.$store.state.filtersBox.minWeight || this.$store.state.filtersBox.weightLimits[0], 10),
                    parseInt(this.$store.state.filtersBox.maxWeight || this.$store.state.filtersBox.weightLimits[1], 10)
                ];
            },

            getDefaultWeight: function () {
                return [
                    parseInt(this.$store.state.filtersBox.weightLimits[0], 10),
                    parseInt(this.$store.state.filtersBox.weightLimits[1], 10)
                ];
            },

            applyFilters: function () {
                let params = _.merge(
                    getUrlParams(), {
                        frame: this.frame,
                        speed: this.speed,
                        minPrice: this.price[0],
                        maxPrice: this.price[1],
                        minWeight: this.weight[0],
                        maxWeight: this.weight[1]
                    }
                );

                GA.event('filters', 'apply', 'Apply bike listing filters');

                setTimeout(() => {
                    setUrlParams(this.addCategoryToPayload(params));
                }, 0);
            },

            initFilters: function () {
                this.price = this.getInitialPrice();
                this.weight = this.getInitialWeight();
                this.category = this.$store.state.filtersBox.category;
                this.frame = this.$store.state.filtersBox.frame;
                this.speed = this.$store.state.filtersBox.speed;
            },

            resetFilters: function () {
                this.price = this.getDefaultPrice();
                this.weight = this.getDefaultWeight();
                this.category = '';
                this.frame = '';
                this.speed = '';
                this.$refs.category.clear();
                this.$refs.frame.clear();
                this.$refs.speed.clear();

                GA.event('filters', 'reset', 'Reset bike listing filters');
            },

            loadResults: function () {
                if (!this.initialized) {
                    return;
                }

                if (!this.filtersChanged) {
                    this.totalResults = this.$store.state.filtersBox.results;
                    return;
                }

                try {
                    this.xhr.abort();
                } catch (e) {
                }

                this.loadingResults = true;

                let payload = this.addCategoryToPayload({
                    frame: this.frame,
                    speed: this.speed,
                    minPrice: this.price[0],
                    maxPrice: this.price[1],
                    minWeight: this.weight[0],
                    maxWeight: this.weight[1]
                });

                let that = this;

                this.xhr = $.ajax({
                    url: this.$store.state.filtersBox.bikesFilterEndpoint,
                    method: 'get',
                    data: payload,
                    success: function (data) {
                        if (data.success) {
                            that.totalResults = data.count;
                        }
                        else {
                            console.error('Wrong payload produced server error:', payload, data);
                            bootbox.alert('Le serveur a retourné une erreur. Veuillez essayer plus tard.');
                        }
                    },
                    error: function (data) {
                        if (data && data.status === 0 && data.statusText === 'abort') {
                            return;
                        }

                        bootbox.alert('Le serveur a retourné une erreur. Veuillez essayer plus tard.');
                    },
                    complete: function () {
                        that.loadingResults = false;
                    }
                });

                GA.event('filters', 'load-results', 'Dynamically load results from bike listing filters control');
            },

            addCategoryToPayload: function (payload) {
                if (this.isBrandCategory) {
                    _.merge(payload, {
                        label: this.$store.state.filtersBox.bikeParentId,
                        brand: this.category
                    })
                }
                else {
                    _.merge(payload, {
                        brand: this.$store.state.filtersBox.bikeParentId,
                        label: this.category
                    })
                }

                return payload;
            }
        }
    }
</script>